<script>
import BirimSecimi2 from "@/router/views/FormComponet/BirimSecimiAnaBirim2.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrIcDegerBirim from "@/models/StrIcDegerBirim";
export default {
  mixins: [Api, Sabit, StrIcDegerBirim],
  props: ["Icdegerid","DegerlendirmeTur"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      FormData: {},  
      AddEdit:"",
      secilmis: [],
      Programlar: false,
      Birimids: [],
      BirimAdis: []
    };
  },
  components: {
    Loader,
    BirimSecimi,
    BirimSecimi2,
  },
  watch: {
    Icdegerid() {
      this.Get();
    },
    secilmis(){
 

    }
  },
  methods: {
    onSubmit() {


        if (this.FormData.Birimids[0] == 1) {
          this.FormData.Birimids.splice(0, 1);
        } 

        if(this.AddEdit == "Add"){
          this.Post("StrIcDegerBirim", this.FormData);

          this.$bvModal.hide("StrIcDegerBirim"); 
              this.$emit("Update");
        }else{
          this.Update("StrIcDegerBirim", this.FormData);
          this.$bvModal.hide("StrIcDegerBirim"); 
              this.$emit("Update");
        }
       
    
    },
    Get() { 
      if(this.Icdegerid){
          this.ActionsFilterGet({Service:"StrIcDegerBirim", Page:this.Page, Filter:"&Icdegerid=" + this.Icdegerid}).then(
            (res) => { 
              if(res.Data.length != 0){  
                this.FormData = res.Data[0]
                this.AddEdit = "Edit"
                this.secilmis = res.Data[0].Birimids
                this.Secilmis_Idler(res.Data[0].Birimids)
              }else{ 
                this.secilmis =[];   
                this.FormData = this.StrIcDegerBirimData
                this.FormData.Icdegerid = this.Icdegerid;
                this.AddEdit = "Add"
              }
            }
          );
      } 
    }, 
    GetProgramlar(){
    if(this.Programlar == false){

          this.FormData.BirimIds = this.Birimids;
          this.FormData.BirimAdis = this.BirimAdis;
    }



    },
    Secilmis_Idler(veriler){
          this.secilmis=veriler;
          if(this.AddEdit == "Add"){
            this.FormData.Birimids=[];
          }
          if (this.secilmis[0]==1){ this.secilmis.splice(0, 1)}

            this.FormData.Birimids=this.secilmis;

          
    },
  },
  created(){
        this.ActionsFilterGet({Service:"obirim",Page:this.Page, Filter:"&BirimTipAdi=Program"}).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.BirimAdis.push (res.Data[i].BirimAdi);
          this.Birimids.push (res.Data[i].Id);
        }    
    }); 
  }
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrIcDegerBirim"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrRiskBirim.AddEdit.FormTitleEdit')
          : $t('StrRiskBirim.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">   

           <!--   <div class="form-check mb-3" v-if="DegerlendirmeTur==3">
                <input id="checkbox-1" v-model="Programlar" @click="GetProgramlar()" class="form-check-input" type="checkbox" name="checkbox-1">
                <label for="checkbox-1" class="form-check-label"> Yalnız Programlar </label>
              </div>   -->

                   <BirimSecimi2  
               v-if="DegerlendirmeTur==3"
                    :title_position="'mb-3'"
                    :selected="FormData.Birimids"
                    :labels_lg="'3'"
                    :FormDataType="FormDataType.Birimids"
                    :v="$v.FormData.Birimids"
                    :multiple="true" 
                    :BirimTipId="null" 
                    :flat="true"
                     @Secilmis_Idler="FormData.BirimIds=$event"
                    />

                    <BirimSecimi  
                    v-if="DegerlendirmeTur!=3"
                    :title_position="'mb-3'"
                    :selected="FormData.Birimids"
                    :labels_lg="'3'"
                    :FormDataType="FormDataType.Birimids"
                    :v="$v.FormData.Birimids"
                    :multiple="true" 
                    :BirimTipId="null" 
                    :flat="true"
                     @Secilmis_Idler="FormData.BirimIds=$event"
                    />
           

        <button class="btn btn-primary" type="submit">
          {{ $t("StrRiskBirim.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
